import React, { useEffect, useRef } from "react";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

const MapPin =
  "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z";

const color='#34424D'

const CustomSkinMap = withGoogleMap((props) => {
 const mapRef=useRef()
  let center = props.selectedMarker ? props.selectedMarker : (props.markers ? props.markers[0] : null);



useEffect(()=>{
if(props.markers)
   { 
    var bounds = new window.google.maps.LatLngBounds();
     for(var i=0;i<props.markers.length;i++){
      let marker=props.markers[i]
      bounds.extend({
        lat: marker.lat,
        lng:marker.lng,
      });
    }
    mapRef.current&&mapRef.current.fitBounds(bounds);
   }
},[props.markers])


  return (
    <>
      <GoogleMap ref={mapRef}
        defaultZoom={10}
        defaultCenter={center && { lat: center.lat, lng: center.lng }}       
        defaultOptions={{
          scrollwheel: true,
          zoomControl: true,
          
        }}
      >
        {props.selected && (
          <InfoBox
            position={{ lat: props.selected.lat, lng: props.selected.lng }}
            options={{ closeBoxURL: ``, enableEventPropagation: true ,pixelOffset:new window.google.maps.Size(-50,-100),maxWidth:300,minWidth:100}}
            
          >
            <div
              style={{
                backgroundColor: "var(--white)",
                color: "var(--darker)",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              {props.selected.title}
            </div>
          </InfoBox>
        )}

        {props.markers &&
          props.markers.map((marker) => {
             return (
              <Marker
                key={marker.id}
                title={marker.title}
                icon={{
                  path: MapPin,
                  fillColor: color,
                  fillOpacity: 0.9,
                  strokeWeight: 1,
                  rotation: 0,
                  scale: 2,
                  strokeColor:'#273540',
                  anchor: new window.google.maps.Point(12, 25),
                }}
                position={{
                  lat: parseFloat(marker.lat),
                  lng: parseFloat(marker.lng),
                }}
              />
            );
          })}
        {props.selected && (
          <Marker icon={{
            path: MapPin,
            fillColor: 'green',
            fillOpacity: 1,
            strokeWeight: 1,
            rotation: 0,
            strokeColor:'#273540',
            scale: 3,
             anchor: new window.google.maps.Point(12, 25),
          }}
            key={props.selected.id}
            position={{ lat: props.selected.lat, lng: props.selected.lng }}
          />
        )}
         {/* {props.selected && (
          <Marker
            key={props.selected.id}
            position={{ lat: props.selected.lat, lng: props.selected.lng }}
          />
        )} */}
      </GoogleMap>
    </>
  );
});

export default function Maps(props) {
  return (
    <div>
      <CustomSkinMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBNC9xN76yYhSl9KyDN0mNoKLa63Fkog1M&v=3.exp&libraries=geometry,drawing,places"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100vh` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        markers={
          props.markers || [
            { title: "Grospick", lat: 40.748817, lng: -73.985428 },
          ]
        }
        selected={props.selectedMarker}
      ></CustomSkinMap>
    </div>
  );
}
